import {isNil} from '../utils/helpers';
import {store} from '../utils/shared/store';

const commentsStore = store({comments: []});

function addReplyToComment (comments, reply, parentCommentId) {
  return comments.map(firstLevelComment => {
    if (firstLevelComment.id === parentCommentId) {
      return {
        ...firstLevelComment,
        replies: [
          reply,
          ...firstLevelComment.replies
        ]
      };
    }
    const secondLevelReplies = firstLevelComment.replies.map(secondLevelComment => {
      if (secondLevelComment.id === parentCommentId) {
        return {
          ...secondLevelComment,
          replies: [
            reply
          ]
        };
      }
      const thirdLevelReplies = secondLevelComment.replies.map(thirdLevelComment => {
        if (thirdLevelComment.id === parentCommentId) {
          return {
            ...thirdLevelComment,
            replies: [
              reply,
              ...thirdLevelComment.replies
            ]
          };
        }
        const fourthLevelReplies = thirdLevelComment.replies.map(fourthLevelComment => {
          if (fourthLevelComment.id === parentCommentId) {
            return {
              ...fourthLevelComment,
              replies: [
                reply,
                ...fourthLevelComment.replies
              ]
            };
          }
          return fourthLevelComment;
        });

        return {...thirdLevelComment, replies: fourthLevelReplies};
      });

      return {...secondLevelComment, replies: thirdLevelReplies};
    });

    return {...firstLevelComment, replies: secondLevelReplies};
  });
}

function addCommentToArticle (comments, commentToAdd) {
  return [
    commentToAdd,
    ...comments
  ];
}

const CommentsMemoryRepository = {
  subscribe: commentsStore.subscribe,
  getComments() {
    return commentsStore.comments;
  },
  setComments(comments) {
    commentsStore.comments = [...comments];
  },
  addReply(parentCommentId, comment) {
    commentsStore.comments = isNil(parentCommentId)
      ? addCommentToArticle(commentsStore.comments, comment)
      : addReplyToComment(commentsStore.comments, comment, parentCommentId);
  }
};

export {CommentsMemoryRepository};
